export enum BalanceScreens {
  BALANCE_MAIN_SCREEN = "BalanceScreen",
  SUCCEED_REFILL_SCREEN = "SucceedScreen",
  MERCANET_LOADING = "MercanetLoading",
  ERROR_RECEIPT = "ErrorReceipt",
  TICKET_PAGE = "TicketPage",
}
